import React from 'react';
import 'bootstrap';
import 'aos'
import '../assets/css/style.css';
import '../assets/vendor/animate.css/animate.min.css';
import '../assets/vendor/aos/aos.css';
import '../assets/vendor/bootstrap/css/bootstrap.min.css';
import '../assets/vendor/bootstrap-icons/bootstrap-icons.css';
import '../assets/vendor/boxicons/css/boxicons.min.css';
import '../assets/vendor/glightbox/css/glightbox.min.css';
import '../assets/vendor/remixicon/remixicon.css';
import '../assets/vendor/swiper/swiper-bundle.min.css';
// import lab from '../assets/img/elnhome.png';
import Templog from '../assets/img/logos-eln/Temp-log.png'
import elnLogo from '../assets/img/logos-eln/logo-2.png'
import test1 from '../assets/img/test1.png'
import log4 from '../assets/img/logos-eln/log-4.png'
import log5 from '../assets/img/logos-eln/log-5.png'
import log6 from '../assets/img/logos-eln/log-6.png'
import log7 from '../assets/img/logos-eln/log-7.png'
import log8 from '../assets/img/logos-eln/log-8.png'
import log9 from '../assets/img/logos-eln/log-9.png'
import log10 from '../assets/img/logos-eln/log-10.png'
import log11 from '../assets/img/logos-eln/log-11.png'
import log13 from '../assets/img/logos-eln/log-13.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsersCog } from '@fortawesome/free-solid-svg-icons';
import { faBoxes } from '@fortawesome/free-solid-svg-icons';
import { Link as RouterLink } from 'react-router-dom';
// import labill1 from './../assets/img/Illustrations/Lab_illustration.jpg';
import eln_chemist from './../assets/img/Illustrations/chemist-amico (1).svg';
import eln_sub_1 from './../assets/img/Illustrations/eln_sub_1.png';
import eln_sub_2 from './../assets/img/Illustrations/eln_sub_2.png';
import eln_sub_3 from './../assets/img/Illustrations/eln_sub_3.png';
// import dots from './../assets/img/Illustrations/Dots.png';
import DownloadBrochure from './DownloadBrochure';
import Faq from './Faq';


const Eln = () => {
    return (<div className='portifoliobody'>
        <main id="main">
            <section id="ELN" className="about text-start" style={{paddingTop:'60px'}}>
                {/* <div className="section-title text-center" data-aos="zoom-out">
                    <h2>Products</h2>
                    <h1 style={{ fontWeight: 'bold',color:'rgba(4,52,111)'}}>LAB ICONICS ELN</h1>
                </div> */}

                <div className='landing-page'>
                    <div>
                        <div className="landing-title carousel-container animate__animated animate__fadeInLeft" data-aos="fade-left" data-aos-delay="100">
                            <h1>Lab Iconics ELN –  The Ultimate Electronic Lab Notebook for Smarter Research</h1>
                            <div style={{width:'87%'}}>
                                <p>
                                    Simplifies experiment documentation, enhances collaboration, ensures data integrity, and accelerates research with secure, cloud-based accessibility.
                                </p>
                            </div>
                            {/* <div className='landing-book-a-demo-div' >
                                <RouterLink to='/demo' href='#REQUEST A DEMO' className='routerLink'>
                                    <div className='landing-book-a-demo-btn' style={{backgroundColor:'#DA81D4'}}>
                                        Get a Demo
                                    </div>
                                </RouterLink>
                            </div> */}
                            <div className="book_a_demo product-demo" style={{padding:'1rem 1rem 0 0'}}>
                                <RouterLink to='/demo'> 
                                    <button className="book_a_demo_btn product-demo-btn">Get a Demo</button>
                                </RouterLink>
                            </div>
                        </div>
                        {/* <div className="left-img">
                            <img src={dots} alt="" />
                        </div> */}
                        <div className="landing-img-div-eln carousel-container col-12 col-lg-6 animate__animated animate__fadeInRight" data-aos="fade-right" data-aos-delay="100">
                            <img src={eln_chemist} alt="" />
                        </div>
                    </div>
                </div>
                {/* <div className="container">
                    <div className='row'>
                        <div className='col-lg-6 mt-2 order-lg-2' style={{fontSize: '17px',fontFamily: 'Arial'}}>
                            <ul>
                                <li>Lab Iconics ELN (Electronic Lab Notebook) is a software tool specifically designed for scientists and researchers. It provides a secure and organized way to record, store, and share research data and results.It helps in Storing and managing laboratory data, including protocols, results, images, and documents.One of the key feature includes Collaboration with other scientists in real-time by sharing data and results.</li>
                                <li>Labiconics ELN is designed to be user-friendly and intuitive, making it easy for researchers to adopt and use. It is also flexible and customizable, allowing it to be adapted to meet the specific needs of different research fields and laboratory environments.</li>
                                <li>Labiconics ELN is a valuable tool for researchers who want to improve the accuracy, reproducibility, and security of their laboratory work. Automate laboratory workflows, reducing the risk of errors and improving efficiency. Generate reports and charts to visualize data and results.</li>
                            </ul>
                        </div>
                        <div className='col-lg-6 order-lg-1 d-flex flex-row justify-content-center'>
                            <img src={lab} className='elnimg ' />
                        </div>
                    </div>
                </div> */}


                <div className="section-container" style={{margin:'0px'}}>
                    <div className="row">
                        <div className="section-pro">
                            <div className="sec-out">
                                <div className="sec-pro-img" data-aos="fade-up" data-aos-delay="100">
                                    <img src={eln_sub_1} alt=""/>
                                </div>  
                                <div className="sec-pro-desc" data-aos="fade-up" data-aos-delay="100">
                                    <div className="sec-title"><h1>Lab Iconics ELN – The Smart Solution For Modern Research</h1></div>
                                    <ul>
                                        <li style={{hyphens:'auto'}}><b>Designed for Scientists & Researchers – </b> A secure and organized platform for recording, storing, and sharing research data.</li>
                                        <li style={{hyphens:'auto'}}><b>Comprehensive Data Management – </b> Store and manage protocols, results, images, and documents in one place.</li>
                                        <li style={{hyphens:'auto'}}><b>Real-Time Collaboration –  </b> Share data instantly and collaborate with other scientists seamlessly.</li>
                                        <li style={{hyphens:'auto'}}><b>User-Friendly & Intuitive –  </b> Easy to adopt, ensuring a smooth learning curve for researchers.</li>
                                        <li style={{hyphens:'auto'}}><b>Enhanced Accuracy & Reproducibility –  </b> Maintain data integrity and streamline documentation.</li>
                                        <li style={{hyphens:'auto'}}><b>Workflow Automation –  </b> Reduce errors, improve efficiency, and accelerate research processes.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="section-pro">
                            <div className="sec-out">
                                <div className="sec-pro-desc" data-aos="fade-up" data-aos-delay="100">
                                    <div className="sec-title-2"><h1>Lab Iconics ELN – Streamlining Lab Documentation & Inventory Management</h1></div>
                                    <ul className='sec-ul'>
                                        <li style={{hyphens:'auto'}}><b>Seamless ELN & LIMS Integration – </b> Ensures real-time data flow between experiment records, sample tracking, and test management.</li>
                                        <li style={{hyphens:'auto'}}><b>Integrated Inventory Management –</b>Tracks reagents, consumables, and lab supplies, preventing shortages and ensuring compliance.</li>
                                        <li style={{hyphens:'auto'}}><b>Enhanced Collaboration – </b> Enables researchers to document, share, and retrieve experiment data securely from a centralized platform. </li>
                                        <li style={{hyphens:'auto'}}><b>Regulatory Compliance & Security – </b>Maintains audit trails, electronic signatures, and version control for data integrity and compliance.</li>
                                    </ul>
                                </div>
                                <div className="sec-pro-img" data-aos="fade-up" data-aos-delay="100">
                                    <img src={eln_sub_2} alt="" style={{width:'80%', marginLeft:'10%'}}/>
                                </div>  
                            </div>
                        </div>

                        <div className="section-pro">
                            <div className="sec-out">
                                <div className="sec-pro-img" data-aos="fade-up" data-aos-delay="100">
                                    <img src={eln_sub_3} alt=""/>
                                </div>  
                                <div className="sec-pro-desc" data-aos="fade-up" data-aos-delay="100">
                                    <div className="sec-title"><h1>Key Benefits of Lab Iconics ELN & Its Integration with LIMS</h1></div>
                                    <ul>
                                        <li style={{hyphens:'auto'}}><b>Seamless Data Flow – </b>Lab Iconics ELN integrates effortlessly with LIMS, ensuring real-time synchronization of experiments, samples, and results.</li>
                                        <li style={{hyphens:'auto'}}><b>Enhanced Compliance & Security – </b> Maintain regulatory compliance with audit trails, digital signatures, and secure access controls across ELN and LIMS.</li>
                                        <li style={{hyphens:'auto'}}><b>Automated Workflows – </b> Reduce manual data entry by automating laboratory processes, minimizing errors, and improving operational efficiency.</li>
                                        <li style={{hyphens:'auto'}}><b>Comprehensive Data Management – </b> Store, track, and analyze experimental data alongside sample and inventory records for a unified research ecosystem.</li>
                                        <li style={{hyphens:'auto'}}><b>Advanced Reporting & Insights – </b> Generate accurate reports, visualize data trends, and make informed decisions with integrated analytics from ELN and LIMS.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                {/* KEY FEATURES 45 */}
                <div className="services">
                    <div className="container services mt-5" >
                        <div className="row">
                            <div className="section-title text-center" data-aos="zoom-out">
                                <h1 style={{ fontWeight: 'bold' ,color:'rgba(4,52,111)'}}>KEY FEATURES</h1>
                            </div>
                            <div className="col-lg-3 col-md-6 mt-5 mb-5">
                                <div className="icon-box icon-outer-div" data-aos="fade-up" data-aos-delay="300">
                                    <div className="title mt-5 ml-5 elnkeyfeatures icon-image" style={{marginLeft:'0px'}}><img alt='' src={Templog} style={{ width: '40px', height: '40px' }} /></div>
                                    <div className="text-center" style={{ fontSize: '20px' }}>Template Management</div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 mt-5 mb-5">
                                <div className="icon-box icon-outer-div" data-aos="fade-up" data-aos-delay="300">
                                    <div className="title mt-5 ml-5 elnkeyfeatures icon-image" style={{marginLeft:'0px'}}><img alt='' src={elnLogo} style={{ width: '40px', height: '40px' }} /></div>
                                    <div className="text-center" style={{ fontSize: '20px' }}>Experiment Management</div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 mt-5 mb-5">
                                <div className="icon-box icon-outer-div" data-aos="fade-up" data-aos-delay="300">
                                    <div className="title mt-5 elnkeyfeatures icon-image" style={{marginLeft:'0px'}}><img alt='' src={test1} style={{ width: '40px', height: '40px' }} /></div>
                                    <div className="text-center" style={{ fontSize: '20px' }}>Test Execution</div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 mt-5 mb-5">
                                <div className="icon-box icon-outer-div" data-aos="fade-up" data-aos-delay="300">
                                    <div className="title mt-5 elnkeyfeatures icon-image" style={{marginLeft:'0px'}}><img alt='' src={log4} style={{ width: '40px', height: '40px' }} /></div>
                                    <div className="text-center" style={{ fontSize: '20px' }}>Workflow Management</div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 mt-5 mb-5">
                                <div className="icon-box icon-outer-div" data-aos="fade-up" data-aos-delay="300">
                                    <div className="title mt-5 elnkeyfeatures icon-image" style={{marginLeft:'0px'}}><img alt='' src={log5} style={{ width: '40px', height: '40px' }} /></div>
                                    <div className="text-center" style={{ fontSize: '20px' }}>Report Management</div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 mt-5 mb-5">
                                <div className="icon-box icon-outer-div" data-aos="fade-up" data-aos-delay="300">
                                    <div className="title mt-5 elnkeyfeatures icon-image" style={{marginLeft:'0px'}}><img alt='' src={log6} style={{ width: '40px', height: '40px' }} /></div>
                                    <div className="text-center" style={{ fontSize: '20px' }}>Inventory Management</div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 mt-5 mb-5">
                                <div className="icon-box icon-outer-div" data-aos="fade-up" data-aos-delay="300">
                                    <div className="title mt-5 elnkeyfeatures icon-image" style={{marginLeft:'0px'}}><img alt='' src={log7} style={{ width: '40px', height: '40px' }} /></div>
                                    <div className="text-center" style={{ fontSize: '20px' }}>Instrument Management</div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 mt-5 mb-5">
                                <div className="icon-box icon-outer-div" data-aos="fade-up" data-aos-delay="300">
                                    <div className="title mt-5 elnkeyfeatures icon-image" style={{marginLeft:'0px'}}><img alt='' src={log8} style={{ width: '40px', height: '40px' }} /></div>
                                    <div className="text-center" style={{ fontSize: '20px' }}>Label Management</div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 mt-5 mb-5">
                                <div className="icon-box icon-outer-div" data-aos="fade-up" data-aos-delay="300">
                                    <div className="title mt-5 elnkeyfeatures icon-image" style={{marginLeft:'0px'}}><img alt='' src={log9} style={{ width: '40px', height: '40px' }} /></div>
                                    <div className="text-center" style={{ fontSize: '20px' }}>Barcode Reader</div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 mt-5 mb-5">
                                <div className="icon-box icon-outer-div" data-aos="fade-up" data-aos-delay="300">
                                    <div className="title mt-5 elnkeyfeatures icon-image" style={{marginLeft:'0px'}}><img alt='' src={log10} style={{ width: '40px', height: '40px' }} /></div>
                                    <div className="text-center" style={{ fontSize: '20px' }}>List Management</div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 mt-5 mb-5">
                                <div className="icon-box icon-outer-div" data-aos="fade-up" data-aos-delay="300">
                                    <div className="title mt-5 elnkeyfeatures icon-image" style={{marginLeft:'0px'}}><img alt='' src={log11} style={{ width: '50px', height: '40px' }} /></div>
                                    <div className="text-center" style={{ fontSize: '20px' }}>Collaboration Management</div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 mt-5 mb-5">
                                <div className="icon-box icon-outer-div" data-aos="fade-up" data-aos-delay="300">
                                    <div className="title mt-5 elnkeyfeatures icon-image" style={{marginLeft:'0px'}}><img alt='' src={log13} style={{ width: '40px', height: '40px' }} /></div>
                                    <div className="text-center" style={{ fontSize: '20px' }}>Third Party Integration</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* HOSTING OPTIONS */}
                <div className="services mt-5">
                    <div className="container services mt-5" >
                        <div className="row">

                            <div className="col-lg-6 col-md-6 mt-5">
                                <div className="icon-box eln" data-aos="fade-up" data-aos-delay="100">
                                    <div className="icon"><i> <FontAwesomeIcon icon={faUsersCog} /></i></div>
                                    <h4 className="title" style={{color:'rgba(4,52,111)'}}><a >Project Management</a></h4>
                                    <p className="description">The project management in LAB ICONICS ELN plays a key role in managing the experiments under respective projects by, assigning the projects to the respective groups.</p>
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6 mt-5">
                                <div className="icon-box eln" data-aos="fade-up" data-aos-delay="100">
                                    <div className="icon"><i className="bi bi-file-earmark-richtext"></i></div>
                                    <h4 className="title" style={{color:'rgba(4,52,111)'}}><a >Forms & Templates</a></h4>
                                    <p className="description">The features in the LAB ICONICS ELN includes Configurable forms and templates, which helps in saving an ample of time by updating / entering the required details in standard template or forms. </p>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 mt-5">
                                <div className="icon-box eln" data-aos="fade-up" data-aos-delay="100">
                                    <div className="icon"><i> <FontAwesomeIcon icon={faBoxes} /></i></div>
                                    <h4 className="title"  style={{color:'rgba(4,52,111)'}}><a >Inventory Management</a></h4>
                                    <p className="description">Lab Iconics LIMS will efficiently perform the task of digital inventory management by recording, tracking and optimising laboratory chemicals, reagents, standards, and solvents. The system will track maintaining the reconciliation of Inventory usage.

                                    </p>
                                    <div className='container'>
                                        <div>
                                            <div className='d-flex flex-row'>
                                                <div>
                                                    <ul className='ml-5' style={{ marginLeft: '65px',fontFamily: "Arial" ,fontSize: '16px'}}>
                                                        <li>Chemical Management</li>
                                                        <li>Material Management</li>
                                                        <li>Reference Standards</li>
                                                        <li>Working Standards</li>

                                                    </ul>
                                                </div>
                                                <div>
                                                    <ul style={{fontFamily: "Arial" ,fontSize: '16px'}}>

                                                    
                                                        <li>Column Management</li>
                                                        <li>Instrument Management</li>
                                                        <li>Solution Management</li>
                                                    </ul>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 mt-5">
                                <div className="icon-box eln" data-aos="fade-up">
                                    <div className="icon">
                                        {/* <i className="fas fa-flask"></i> */}
                                        <FontAwesomeIcon icon='fa-flask'style={{height:'65px'}} />
                                    </div>
                                    <h4 className="title" style={{color:'rgba(4,52,111)'}}><a >Experiment Management</a></h4>
                                    <p className="description">The experiment management of LAB ICONICS ELN is the core/vital module where a provision to manage the whole experiment, it incorporates features like importing files, media, documents as an attachment/reference, also Chemical Structure drawing is one of the finest features along with the calculations.
                                    </p>
                                    <ul className='ml-5' style={{ marginLeft: '65px',fontSize: '16px',fontFamily: 'Arial' }}>
                                        <li>Sections</li>
                                        <li>Templates</li></ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
        <div className="down-broch" data-aos="fade-up">
            <DownloadBrochure product={'ELN'}/>
        </div>
        <div data-aos="fade-up">
            <Faq product={'ELN'}/>
        </div>


        {/* <svg className="hero-waves" style={{ background: 'rgba(4,52,111)' }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 24 150 28" preserveAspectRatio="none">
            <defs>
                <path id="wave-path" d="M-160 44c30 0 58-18 88-18s58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
            </defs>
            <g className="wave1">
                <use xlinkHref="#wave-path" x="50" y="3" fill="rgba(255,255,255, .1)" />
            </g>
            <g className="wave2">
                <use xlinkHref="#wave-path" x="50" y="0" fill="rgba(255,255,255, .2)" />
            </g>
            <g className="wave3">
                <use xlinkHref="#wave-path" x="50" y="9" fill="#fff" />
            </g>
        </svg> */}
    </div>

    );
};

export default Eln;